import i18n from '@shared/i18n/index';

export const {
	API_Copied_Toast,
	ImageDetails_DownloadTips_Toast,
	UserSettingModal_Success_Toast,
	Login_LoginSucceed_Toast,
	Business_PublishSuccess_Toast,
	Common_CopyLinkSuccess_Toast,
	Business_CopiedLink_Toast,
	Business_WaitEnhanceCompleted_Toast,
	Business_PleaseWaitOptimize_Toast,
	Login_LogOutSucceed_Toast,
	Business_Share_Toast,
	UserSettingModal_NoEmpty_Toast,
	Login_VerifyCode_Wrong_Toast,
	Login_Email_NoRegister_Toast,
	Login_User_Already_Exist_Toast,
	Login_User_NoExist_Toast,
	Task_Empty_Toast,
	Common_Invite_Friend_Register_Alert,
	Common_UnPublish_Success,
	Images_Press_Save,
	Build_Select_Less_Toast,
	Build_Something_Wrong_Toast,
	Common_Try_Later_Toast,
	Common_Wait_Optimization_Complete_Toast,
	Common_Request_Error_Toast,
	Common_Please_Retry_Toast,
	Business_PleaseReCreate_Toast,
	CreditsPlan_CancelSubscribedPlan_Action,
	Build_Image_Upload_Error_Toast,
	Common_Delete_Toast,
	Common_Delete_Error_Toast,
	Build_DeleteAvatar_Toast,
	Common_The_Image_Has_Published_Toast,
	Build_Image_Oversize_Toast,
	Common_Optimize_Already_Success_Toast,
	Common_Failed_Revert_AppVersion_Toast,
	Common_Check_Network_Toast,
	Common_GroupPhoto_NoCreateDigital_Toast,
	Common_Verification_Code_Toast,
	Build_GroupPhoto_Reoad_Toast,
	Common_Reset_Password_Toast,
	Common_Sign_Up_Succeeded_Toast,
	Build_Work_NoExist_Toast,
	Common_Not_Exist_Toast,
	AddHomescreen_Toast_Receive,
	AddHomescreen_Toast_Receivealready,
	Image_Upload_Prohibited_Toast,
	// 生成校验模块
	STYLE_ONE,
	ITEM_ONE,
	DIGITAL,
	AUTOSAVE,
	IS_UPLOAD,
	GROUP_CNET,
	VIDEO_UPLOAD,
	ANY_NEEDED,
	IS_PROHIBITED,
	ILLEGAL_COMP,
	Build_Fork_WithoutModification_Toast,
	Signup_Facebook_Error_Toast,
	GEN_IN_DETAIL,
	FACESWAP_VIDEO_SOUND,
	FaceSwap_NoImageError,
	Motion_Video_Toast,
	Common_Short_Film_premium_toast,
} = {
	API_Copied_Toast: () => i18n.get('API_Copied_Toast'),
	ImageDetails_DownloadTips_Toast: () => i18n.get('ImageDetails_DownloadTips_Toast'),
	UserSettingModal_Success_Toast: () => i18n.get('UserSettingModal_Success_Toast'),
	Login_LoginSucceed_Toast: () => i18n.get('Login_LoginSucceed_Toast'),
	Business_PublishSuccess_Toast: () => i18n.get('Business_PublishSuccess_Toast'),
	Common_CopyLinkSuccess_Toast: () => i18n.get('Common_CopyLinkSuccess_Toast'),
	Business_CopiedLink_Toast: () => i18n.get('Business_Share_Copy_Toast'),
	Business_WaitEnhanceCompleted_Toast: () => i18n.get('Business_WaitEnhanceCompleted_Toast'),
	Business_PleaseWaitOptimize_Toast: () => i18n.get('Business_PleaseWaitOptimize_Toast'),
	Login_LogOutSucceed_Toast: () => i18n.get('Login_LogOutSucceed_Toast'),
	Business_Share_Toast: () => i18n.get('Business_Share_Toast'),
	UserSettingModal_NoEmpty_Toast: () => i18n.get('UserSettingModal_NoEmpty_Toast'),
	Login_VerifyCode_Wrong_Toast: () => i18n.get('Login_VerifyCode_Wrong_Toast'),
	Login_Email_NoRegister_Toast: () => i18n.get('Login_Email_NoRegister_Toast'),
	Login_User_Already_Exist_Toast: () => i18n.get('Login_User_Already_Exist_Toast'),
	Login_User_NoExist_Toast: () => i18n.get('Login_User_NoExist_Toast'),
	Task_Empty_Toast: () => i18n.get('Task_Empty_Toast'),
	Common_Invite_Friend_Register_Alert: () => i18n.get('Common_Invite_Friend_Register_Alert'),
	Common_UnPublish_Success: () => i18n.get('Common_UnPublish_Success'),
	Images_Press_Save: () => i18n.get('Images_Press_Save'),
	Build_Select_Less_Toast: () => i18n.get('Build_Select_Less_Toast'),
	Build_Something_Wrong_Toast: () => i18n.get('Build_Something_Wrong_Toast'),
	Common_Try_Later_Toast: () => i18n.get('Common_Try_Later_Toast'),
	Common_Wait_Optimization_Complete_Toast: () =>
		i18n.get('Common_Wait_Optimization_Complete_Toast'),
	Common_Request_Error_Toast: () => i18n.get('Common_Request_Error_Toast'),
	Common_Please_Retry_Toast: () => i18n.get('Common_Please_Retry_Toast'),
	Business_PleaseReCreate_Toast: () => i18n.get('Business_PleaseReCreate_Toast'),
	CreditsPlan_CancelSubscribedPlan_Action: () =>
		i18n.get('CreditsPlan_CancelSubscribedPlan_Action'),
	Build_Image_Upload_Error_Toast: () => i18n.get('Build_Image_Upload_Error_Toast'),
	Image_Upload_Prohibited_Toast: () => i18n.get('Upload_ReferenceImage_Toast'),
	Common_Delete_Toast: () => i18n.get('Common_Delete_Toast'),
	Common_Delete_Error_Toast: () => i18n.get('Common_Delete_Error_Toast'),
	Build_DeleteAvatar_Toast: () => i18n.get('Build_DeleteAvatar_Toast'),
	Common_The_Image_Has_Published_Toast: () => i18n.get('Common_The_Image_Has_Published_Toast'),
	Build_Image_Oversize_Toast: () => i18n.get('Build_Image_Oversize_Toast'),
	Common_Optimize_Already_Success_Toast: () => i18n.get('Common_Optimize_Already_Success_Toast'),
	Common_Failed_Revert_AppVersion_Toast: () => i18n.get('Common_Failed_Revert_AppVersion_Toast'),
	Common_Check_Network_Toast: () => i18n.get('Common_Check_Network_Toast'),
	Common_GroupPhoto_NoCreateDigital_Toast: () =>
		i18n.get('Common_GroupPhoto_NoCreateDigital_Toast'),
	Common_Verification_Code_Toast: () => i18n.get('Common_Verification_Code_Toast'),
	Build_GroupPhoto_Reoad_Toast: () => i18n.get('Build_GroupPhoto_Reoad_Toast'),
	Common_Reset_Password_Toast: () => i18n.get('Common_Reset_Password_Toast'),
	Common_Sign_Up_Succeeded_Toast: () => i18n.get('Common_Sign_Up_Succeeded_Toast'),
	Build_Work_NoExist_Toast: () => i18n.get('Build_Work_NoExist_Toast'),
	Common_Not_Exist_Toast: () => i18n.get('Common_Not_Exist_Toast'),
	AddHomescreen_Toast_Receive: () => i18n.get('AddHomescreen_Toast_Receive'),
	AddHomescreen_Toast_Receivealready: () => i18n.get('AddHomescreen_Toast_Receivealready'),
	STYLE_ONE: () => i18n.get('Build_BuildPage_StyleOne_Toast'),
	ITEM_ONE: () => i18n.get('Build_BuildPage_ItemOne_Toast'),
	DIGITAL: () => i18n.get('Build_BuildPage_Digital_Toast'),
	AUTOSAVE: () => i18n.get('Build_BuildPage_Autosave_Toast'),
	IS_UPLOAD: () => i18n.get('Build_BuildPage_IsUpload_Toast'),
	GROUP_CNET: () => i18n.get('Build_BuildPage_GroupCnet_Toast'),
	VIDEO_UPLOAD: () => i18n.get('Build_BuildPage_VideoUpload_Toast'),
	ANY_NEEDED: () => i18n.get('Build_BuildPage_AnyNeeded_Toast'),
	IS_PROHIBITED: () => i18n.get('Build_BuildPage_Prohbitwords_Toast'),
	ILLEGAL_COMP: () => i18n.get('Build_BuildPage_IllegalComp_Toast'),
	Build_Fork_WithoutModification_Toast: () => i18n.get('Build_Fork_WithoutModification_Toast'),
	Signup_Facebook_Error_Toast: () => i18n.get('Signup_Facebook_Error_Toast'),
	GEN_IN_DETAIL: () => i18n.get('Workflow_Toast_Param_Lack'),
	FACESWAP_VIDEO_SOUND: () => i18n.get('FaceSwap_Videosound_Toast'),
	FaceSwap_NoImageError: () => i18n.get('FaceSwap_NoImageError_Toast'),
	Motion_Video_Toast: () => i18n.get('MotionImitation_Video_Toast'),
	Common_Short_Film_premium_toast: () => i18n.get('Common_Short_Film_premium_toast'),
};
